import { useCallback } from 'react';
import { api } from 'src/constants/apiRoutes';
import useAsync from 'src/hooks/useAsync';
import axiosInstance from 'src/utils/axios';

interface CreateCalendarYearRequest {
  companyId: number;
  noOfYears: number;
}

const useCreateCalendarYearApi = () => {
  const call = useCallback(
    (req?: CreateCalendarYearRequest) =>
      new Promise((resolve, reject) => {
        axiosInstance
          .post(api.createCalendarYear(), req)
          .then((data) => {
            resolve(data.data);
            return data.data;
          })
          .catch((e) => {
            reject(new Error(e));
          });
      }),
    []
  );

  const { execute, isLoading } = useAsync(call, false);

  return {
    createCalendarYear: execute,
    isCreateInvoiceLoading: isLoading,
  };
};

export default useCreateCalendarYearApi;
